// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6403181d","703":"52a8268b"}[chunkId] + ".chunk.js";
};